import { supabase } from './supabase';
import { ArticleLearningRow } from '../types/articleGeneration';

const TABLE = 'article_generation_learnings';

/** Editor notes on highlighted passages, stored per company and domain. */
export const articleLearningsService = {
  /** Newest first; `domainId` null lists every domain of the company. */
  list: async (companyId: string, domainId: string | null): Promise<ArticleLearningRow[]> => {
    let query = supabase.from(TABLE).select('*').eq('company_id', companyId);
    if (domainId) query = query.eq('domain_id', domainId);
    const { data, error } = await query.order('created_at', { ascending: false });
    if (error) throw error;
    return (data ?? []) as ArticleLearningRow[];
  },

  setUseInGeneration: async (id: string, use: boolean): Promise<void> => {
    const { error } = await supabase.from(TABLE).update({ use_in_generation: use }).eq('id', id);
    if (error) throw error;
  },

  remove: async (id: string): Promise<void> => {
    const { error } = await supabase.from(TABLE).delete().eq('id', id);
    if (error) throw error;
  },
};
